/**
 * Number Format To Decimal.
 * @param {*} value
 * @returns {*}
 */
window.number_format_to_decimal = function(value) {
    let decimal = "0.00";
    let count_comma_seperators = 0;
    let count_dot_seperators = 0;
    if (value.indexOf(",") != "-1") {
        count_comma_seperators += value.split(",").length - 1;
    }
    if (value.indexOf(".") != "-1") {
        count_dot_seperators += value.split(".").length - 1;
    }
    if (count_comma_seperators === 1 && count_dot_seperators == 0) {
        decimal = value.replace(",", ".");
    } else if (count_comma_seperators === 0 && count_dot_seperators == 1) {
        decimal = value;
    } else if (count_comma_seperators === 1 && count_dot_seperators == 1) {
        decimal = value.replace(",", ".");
        decimal = decimal.replace(/[.](?![^.]*$)/, "");
    } else if (count_comma_seperators === 0 && count_dot_seperators > 1) {
        decimal = value.replace(/\./g, "");
    } else if (count_comma_seperators > 1 && count_dot_seperators == 0) {
        decimal = value.replace(/\,/g, "");
    } else if (count_comma_seperators === 1 && count_dot_seperators > 1) {
        decimal = value.replace(/\./g, "");
        decimal = decimal.replace(/\,/g, ".");
    } else if (count_comma_seperators > 1 && count_dot_seperators == 1) {
        decimal = value.replace(/\,/g, "");
    } else {
        decimal = value;
    }
    return decimal;
};
